class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      console.log('sync gift working via cartUpdate event');
      syncGift();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => { this.classList.add('animate', 'active') });

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
        this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    if ($('.buy_more_cart').length) {

      if (!$('.buy_more_cart').hasClass('slick-initialized')) {
        $('.buy_more_cart').slick({
          infinite: false,
          slidesToShow: 2,
          slidesToScroll: 1,
          responsive: [
            {
              breakpoint: 1300,
              settings: {
                slidesToShow: 2,
              }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
          ]
        });
      }

      // use existing state instead of re-fetching cart.js again
      const cart = parsedState;
      if (cart.total_price < 5900) {
        $(".cart-item-free .remove_cart_item").trigger("click");
      }

      if (cart.item_count == 0) {
        localStorage.removeItem("CountTimer");
      }
      console.log(222);
    }

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();

      // Call handleCartUpsellVariantChange for all upsell containers after cart update
      const upsellContainers = this.querySelectorAll('.cart-upsell-container, [data-upsell-container]');
      upsellContainers.forEach((container, index) => {
        const optionPrefix = container.dataset.optionPrefix || `upsell-option-${index}`;
        const imageSelector = container.dataset.imageSelector || '.upsell-image';
        window.handleCartUpsellVariantChange(`[data-upsell-container="${container.dataset.upsellContainer}"]`, optionPrefix, imageSelector);
      });

      // Sync free gift based on cart threshold
      console.log('sync gift wokring');
      syncGift();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

// Gift sync configuration and functions
const GIFT_VARIANT_ID = 48550725091580;
const THRESHOLD = 10000; // $100 in cents
let giftProcessing = false;

async function getCart() {
  const res = await fetch('/cart.js');
  return await res.json();
}

function moveGiftCardToStickyHeader() {
  const giftCard = document.querySelector('.fs-gift-unlocked-card');
  const stickyHeader = document.querySelector('.drawer__header-free-sticky');
  
  if (giftCard && stickyHeader) {
    // Clone the gift card to preserve event listeners if any
    const giftCardClone = giftCard.cloneNode(true);
    // Clear sticky header and append the gift card
    stickyHeader.innerHTML = '';
    stickyHeader.appendChild(giftCardClone);
    $('.drawer__header-free-sticky .fs-gift-unlocked-card.fs-hidden').removeClass('fs-hidden');
    // Optionally hide original or keep it in both places
    // giftCard.style.display = 'none';
    console.log('Gift card moved to sticky header');
    
    // Add scroll detection for sticky effect
    setupGiftCardScrollListener();
  }
}

function setupGiftCardScrollListener() {
  const cartDrawer = document.querySelector('cart-drawer');
  const giftCardInHeader = document.querySelector('body');
  
  if (!cartDrawer || !giftCardInHeader) return;
  
  const scrollContainer = cartDrawer.querySelector('cart-drawer-items') || cartDrawer.querySelector('.cart-drawer-items-and-upsell') || cartDrawer.querySelector('.drawer__inner');
  
  if (scrollContainer) {
    scrollContainer.addEventListener('scroll', function() {
      const scrollTop = scrollContainer.scrollTop;
      console.log('123246')
      // Add class when scrolled to top (within 10px)
      if (scrollTop > 200) {
        giftCardInHeader.classList.add('is-at-top');
      } else {
        giftCardInHeader.classList.remove('is-at-top');
      }
    });
    
    // Trigger once on load to set initial state
    scrollContainer.dispatchEvent(new Event('scroll'));
  }
}

async function syncGift() {
  if (giftProcessing) return;
  giftProcessing = true;

  try {
    const cart = await getCart();
    let subtotal = 0;
    let giftItem = null;

    cart.items.forEach(item => {
      if (Number(item.variant_id) === Number(GIFT_VARIANT_ID)) {
        giftItem = item;
      } else {
        subtotal += item.final_line_price;
      }
    });

    // ADD gift - double-check giftItem is still null before adding to prevent race conditions
    if (subtotal >= THRESHOLD && !giftItem) {
      // Re-check cart one more time before adding to prevent duplicates
      const freshCart = await getCart();
      const giftExists = freshCart.items.some(item => Number(item.variant_id) === Number(GIFT_VARIANT_ID));

      if (!giftExists) {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: GIFT_VARIANT_ID, quantity: 1 })
        });
        // Reload page or refresh cart to show updated state
        // window.location.reload();
        console.log('gift added');
      
        // Fetch and re-render cart drawer section to show the gift
        fetch('/cart?section_id=cart-drawer')
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer) {
              const newDrawerInner = html.querySelector('.drawer__inner');
              if (newDrawerInner) {
                cartDrawer.querySelector('.drawer__inner').innerHTML = newDrawerInner.innerHTML;
              }
            }
            // Move gift unlocked card to sticky header
            moveGiftCardToStickyHeader();
            // publish(PUB_SUB_EVENTS.cartUpdate, {source: 'gift-sync'});
          })
          .catch((e) => console.error('Error refreshing cart drawer:', e));
        return;
      }
    }

    // REMOVE gift
    if (subtotal < THRESHOLD && giftItem) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: giftItem.key, quantity: 0 })
      });
      
       fetch('/cart?section_id=cart-drawer')
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer) {
              const newDrawerInner = html.querySelector('.drawer__inner');
              if (newDrawerInner) {
                cartDrawer.querySelector('.drawer__inner').innerHTML = newDrawerInner.innerHTML;
              }
            }
              // publish(PUB_SUB_EVENTS.cartUpdate, {source: 'gift-sync'});
          })
          .catch((e) => console.error('Error refreshing cart drawer:', e));
    }
  } catch (err) {
    console.error('Gift sync error:', err);
  } finally {
    giftProcessing = false;
  }
}

// Global function for handling cart upsell variant changes
window.handleCartUpsellVariantChange = function(containerSelector, optionPrefix, imageSelector) {
  const container = document.querySelector(containerSelector);
  if (!container) return;

  const variantWrapper = container.querySelector('[id^="variant-selects"]');
  const productForm = container.querySelector('.form');
  const productIdField = productForm?.querySelector('input[name="id"]');
  const img = container.querySelector(imageSelector);

  if (!variantWrapper || !productIdField) return;

  const variants = JSON.parse(variantWrapper.querySelector('script[type="application/json"]').textContent);

  const selectedVariant = variants.find((variant) => {
    return variant.options.every((opt, i) => {
      const select = document.querySelector(`#${optionPrefix}-${i}`);
      return select && select.value === opt;
    });
  });

  if (!selectedVariant) return;

  productIdField.value = selectedVariant.id;
  variantWrapper.setAttribute('data-product-id', selectedVariant.id);

  // Popup image support
  if (selectedVariant.popup_image) {
    img.src = selectedVariant.popup_image;
  }
};

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

moveGiftCardToStickyHeader();
// Add scroll detection for sticky effect
window.onload = function() {
  setupGiftCardScrollListener();
};


customElements.define('cart-drawer-items', CartDrawerItems);
